var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-steps',{attrs:{"direction":_vm.direction,"active":_vm.active}},_vm._l((_vm.data),function(item,index){return _c('van-step',{key:index},[_c('h3',[_vm._v(_vm._s(item.Text))]),_c('p',[_vm._v(_vm._s(item.CreateTimeStr))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }